"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.com.choose_model': 'Elegir modelo',
    'ai.com.choose_provider': 'Elegir proveedor',
    'ai.com.choose_avatar': 'Elegir avatar',
};
